import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Flex,
  Heading,
  Text,
  Image,
  VStack,
  HStack,
  Spacer,
  Divider,
} from '@chakra-ui/react';
import { converteLevel } from 'utils/dynConverter';

const PromptCard = ({ promptData, defaultShow, labelShift }) => {
  const [showPrompt, setShowPrompt] = useState(defaultShow);
  const { essayTitle, level, essayType, essayPrompt, url, minWordCount } =
    promptData;
  // const { essayTitle, level, essayType, essayPrompt, minWordCount } =
  //   promptData;
  // const url =
  //   'https://images.cartoonstock.com/lowres_800/money-banking-expensive_restaurant-posh_restaurant-restaurant_bill-restaurant_check-restaurant_cheque-amrn1157_low.jpg';

  const togglePrompt = () => setShowPrompt((prev) => !prev);

  return (
    <Box width={'100%'}>
      <Flex justify="flex-end" mb={2}>
        <Text
          color="blue.500"
          cursor="pointer"
          textDecoration="underline"
          onClick={togglePrompt}
          marginRight={labelShift ? 2 : 0}
        >
          {showPrompt ? 'Hide Prompt' : 'Show Prompt'}
        </Text>
      </Flex>

      {showPrompt && (
        <Box
          p={5}
          borderWidth="1px"
          borderRadius="lg"
          boxShadow="md"
          bg="green.50"
          mb={6}
        >
          <VStack align="start" spacing={4}>
            <Heading size="md" color="teal.700">
              Writing Prompt
            </Heading>

            {essayTitle && (
              <Box>
                <Text fontWeight="bold" color="gray.600">
                  Title:
                </Text>
                <Text>{essayTitle}</Text>
              </Box>
            )}

            <HStack w="100%">
              <Box>
                <Text fontWeight="bold" color="gray.600">
                  Level:
                </Text>
                <Text>{converteLevel(level)}</Text>
              </Box>
              <Spacer />
              <Box>
                <Text fontWeight="bold" color="gray.600">
                  Essay Type:
                </Text>
                <Text>{essayType}</Text>
              </Box>
              <Spacer />
              {minWordCount && (
                <>
                  <Box>
                    <Text fontWeight="bold" color="gray.600">
                      Minimum Word Count:
                    </Text>
                    <Text>{minWordCount}</Text>
                  </Box>
                </>
              )}
            </HStack>
            <Divider />

            <HStack align="start" w="100%">
              <Box>
                <Text fontWeight="bold" color="gray.600">
                  Prompt / Instruction:
                </Text>
                <Text textAlign="justify" color="gray.700">
                  {essayPrompt}
                </Text>
              </Box>
              <Spacer />
              {url && (
                <Flex justifyContent="center" mt={1}>
                  <Image
                    src={url}
                    alt="Essay Image"
                    borderRadius="md"
                    maxH="200px"
                    objectFit="cover"
                  />
                </Flex>
              )}
            </HStack>
          </VStack>
        </Box>
      )}
    </Box>
  );
};

PromptCard.propTypes = {
  promptData: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  defaultShow: PropTypes.bool,
  labelShift: PropTypes.bool,
};

export default PromptCard;
